<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goback()"></span>
    </div>

    <div class="title">请确认订单详情</div>

    <img class="prepay-img" src='../../assets/img/other/prepay-amount.png'>

      <div class="weui-cells__title">预计价格（仅作参考，以实际服务为准）</div>

      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p v-if="order.data.type_id=='1550735962'">出车费</p>
                <p v-else>基础服务费</p>
            </div>
            <div class="weui-cell__ft" v-if="pricing.labor_cost>0">{{pricing.labor_cost | numeral('$0,0.00')}}</div>
            <div class="weui-cell__ft" v-if="pricing.labor_cost==0">户型特殊，客服将电话回访报价</div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="pricing.duplex_cost">
            <div class="weui-cell__bd">
                <p>复式户型费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.duplex_cost">{{pricing.duplex_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" v-if="pricing.carpet_cost">
            <div class="weui-cell__bd">
                <p>地毯清洁费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.carpet_cost">{{pricing.carpet_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>GST费用</p>
            </div>
            <div class="weui-cell__ft">
              <span>总费用10%</span>
            </div>
        </a>
        <label class="weui-cell weui-check__label car">
            <div class="weui-cell__bd">
                <p class="park-assist"  @click="editData(priceSheet)"> <span class="icon-info parking-icon"></span> 点击查看收费标准 </p>
            </div>
        </label>
      </div>
      <div class="weui-cells__title">优惠券</div>
      <div class="weui-cells coupon-cell">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/coupon-apply')">
            <div class="weui-cell__bd">
                <p>优惠券</p>
            </div>
            <div class="weui-cell__ft" v-if="order.data.coupon_id">{{order.data.coupon_title | uppercase}}</div>
            <div class="weui-cell__ft" v-else> <span class="icon-coupon"></span> 点击使用 </div>
        </a>
      </div>

      <div class="weui-cells__title">Coupon Code 优惠码：</div>
      <div class="weui-cells">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <input class="weui-input" type="text" placeholder="请输入优惠码" v-model="order.data.agency">
              </div>
          </div>
      </div>
      <div class="weui-cells__title">服务详情，点击可修改</div>
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>服务类型</p>
            </div>
            <div class="weui-cell__ft">{{service_type}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/cleanex-step1')">
            <div class="weui-cell__bd">
                <p>清洁户型</p>
            </div>
            <div class="weui-cell__ft">{{house_type_duplex}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/cleanex-step2')" v-if="order.data.type_id!='1550735962'">
            <div class="weui-cell__bd">
                <p>清洁房间</p>
            </div>
            <div class="weui-cell__ft">{{room_qty}}</div>
        </a>

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/cleanex-step4')">
            <div class="weui-cell__bd">
                <p>服务时间</p>
            </div>
            <div class="weui-cell__ft">{{order.data.service_date | moment("YYYY年M月D日")}} {{service_period}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/cleanex-step3')">
            <div class="weui-cell__bd">
                <p>清洁地址</p>
            </div>
            <div class="weui-cell__ft">{{order.data.address_street}}, {{order.data.address_suburb}}, {{order.data.address_state}}, {{order.data.address_postcode}}<br>{{toTextFloor(order.data.floor)}} {{toTextParking(order.data.parking)}}</div>
        </a>

      </div>
      <div class="weui-cells__title">留言备注</div>
      <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <textarea class="weui-textarea" placeholder="如果有特殊需求，请在此备注留言" rows="2"  v-model="order.data.msg"></textarea>
              </div>
          </div>
      </div>
      <div class="weui-cells__title">中介推荐码</div>
      <div class="weui-cells">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <input class="weui-input" type="text" placeholder="如果由中介推荐，请输入中介推荐码" v-model="order.data.agency">
              </div>
          </div>
      </div>
      <br>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn active" @click="isSubmiting=true">创建订单</div>
        </div>
      </div>
      <div class="js_dialog" v-show="isSubmiting">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">温馨提醒</strong></div>
              <div class="weui-dialog__bd">请确保服务信息无误，提交后信息将被锁定，只能联系客服修改</div>
              <div class="weui-dialog__ft">
                  <div  class="weui-dialog__btn weui-dialog__btn_default" @click="isSubmiting=false">关闭</div>
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="submitOrder()">确定提交</div>
              </div>
          </div>
      </div>

      <transition name="fade">
          <div id="loadingToast" v-show="isSendingPricing">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取报价</p>
              </div>
          </div>
      </transition>

      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在提交</p>
              </div>
          </div>
      </transition>
      <img :src="pixelURL('clean','xiadan')" class="hide">
    </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'finalStep',
  data () {
    return {
      order:{},
      isSending:false,
      isSendingPricing:false,
      isSubmiting:false,
      pricing:{},
    }
  },
  methods: {
    editData(url){
      localStorage.isEditing = '/cleanex-step5';
      this.$router.push(url);
    },
    goback(){
      if(this.$route.query.src == 'order'){
        this.$router.push('/order');
      }
      else{
        this.$router.push('/cleanex-step4');
      }
    },

    getPricing(){
      if(this.isSendingPricing){
        return false;
      }
      else{
        this.isSendingPricing = true;
        let that = this;

        //做对象的副本出来
        let orderObject = JSON.parse(JSON.stringify(this.order.data));

        if(orderObject.is_duplex=="0"){
          orderObject.duplex_floor = 0;
        }

        orderObject.house_type = this.dataLint("house_type",orderObject.house_type);
        orderObject.house_layout = this.dataLint("house_layout",orderObject.house_layout);
        orderObject.carpet = this.dataLint("carpet",orderObject.carpet);
        orderObject.duplex_floor = this.dataLint("duplex_floor",orderObject.duplex_floor);

        console.log(orderObject);

        this.axios.post(this.apiURL()+'/Cost/getCost', qs.stringify(orderObject))
        .then(function (response) {
          console.log(response);
          if(response.data.error_code==0){
            that.pricing = response.data.data;
            that.isSendingPricing=false;
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSendingPricing=false;
          }
        })
        .catch(function (error) {
          alert("获取报价失败，请检查网络并尝试刷新页面")
          that.isSendingPricing=false;
          console.log(error);
        });
      }
    },

    submitOrder(){
      this.isSubmiting = false;
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        this.orderUpdate('agency',this.order.data.agency)
        this.orderUpdate('msg',this.order.data.msg)

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        //往备注里补充用户第一页选择的服务详情
        orderObject.msg = orderObject.msg + " " + this.order.data.msgAttach;

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
            orderObject.member_name = localStorage.member_name;
            orderObject.member_phone = localStorage.member_phone;
            orderObject.member_mail = localStorage.member_mail;
        }
        else{
            orderObject.token = 0;
            orderObject.member_name = orderObject.address_name;
            orderObject.member_phone = orderObject.address_phone;
        }

        orderObject.service_date = new Date(orderObject.service_date);
        orderObject.service_date = Vue.filter('moment')(orderObject.service_date,"YYYY-MM-DD");

        if(orderObject.is_duplex=="0"){
          orderObject.duplex_floor = 0;
        }

        orderObject.house_type = this.dataLint("house_type",orderObject.house_type);
        orderObject.house_layout = this.dataLint("house_layout",orderObject.house_layout);
        orderObject.duplex_floor = this.dataLint("duplex_floor",orderObject.duplex_floor);
        orderObject.carpet = this.dataLint("carpet",orderObject.carpet);

        orderObject['order_source'] = '3';

        console.log(orderObject);

        this.axios.post(this.apiURL()+'/Order/createOrder', qs.stringify(orderObject))
        .then(function (response) {
          console.log(response);
          if(response.data.error_code==0){
            localStorage.removeItem('savedClean');
            localStorage.removeItem('order');

            let modalString = "";
            if(that.pricing.labor_cost==0){
              modalString = "&notify=clean-rooms";
            }

            localStorage.is_questions = response.data.data.is_questions;
            localStorage.phone_question = orderObject.member_phone;
            localStorage.questions = JSON.stringify(response.data.data.questions);
            
            that.$router.push('/order-prepay?id='+response.data.data.order_number+'&status=0&amount='+that.depositAmount()+modalString);
            if(response.data.data.accoun_status>=0){
              localStorage.account_status = response.data.data.accoun_status;
            }
            if(response.data.data.accoun_status == 2){
              localStorage.token = response.data.data.token;
              localStorage.member_phone = response.data.data.phone;
              localStorage.member_name = response.data.data.name;
              localStorage.tempPasswd = response.data.data.password;
            }
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },

    dataLint(name,value){
        let result ="";

        if (name == "house_type"){
          switch (value) {
            case "1":
              result = "1552109724"
              break;
            case "2":
              result = "1552109729"
              break;
            case "3":
              result = "1552109735"
              break;
            case "4":
              result = "1552109742"
              break;
            case "5":
              result = "1558079273"
              break;
            case "6":
              result = "1552109747"
              break;
            default:
              console.log("5");
          }
        }

        //大扫除
        if(this.order.data.type_id=="1550735948"){
            if (name == "house_layout"){
                switch (value.toString()) {
                case "1":
                    result = "1562650449"
                    break;
                case "2":
                    result = "1562650659"
                    break;
                case "3":
                    result = "1562650676"
                    break;
                case "4":
                    result = "1562650704"
                    break;
                case "5":
                    result = "1562650704"
                    break;
                case "6":
                    result = "1562650721"
                    break;
                case "7":
                    result = "1562654198"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "carpet"){
                switch (value.toString()) {
                case "1":
                    result = "1562655269"
                    break;
                case "2":
                    result = "1562655276"
                    break;
                case "3":
                    result = "1562655284"
                    break;
                case "4":
                    result = "1562655289"
                    break;
                case "5":
                    result = "1562655295"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "duplex_floor"){
                switch (value.toString()) {
                case "2":
                    result = "1562656442"
                    break;
                case "3":
                    result = "1562656448"
                    break;
                case "4":
                    result = "1562656455"
                    break;
                case "5":
                    result = "1562656462"
                    break;
                default:
                    console.log("5");
                }
            }
        }


        //短租屋
        if(this.order.data.type_id=="1550735961"){
            if (name == "house_layout"){
                switch (value.toString()) {
                case "1":
                    result = "1562660387"
                    break;
                case "2":
                    result = "1562660393"
                    break;
                case "3":
                    result = "1562660401"
                    break;
                case "4":
                    result = "1562660407"
                    break;
                case "5":
                    result = "1562660413"
                    break;
                case "6":
                    result = "1562660422"
                    break;
                case "7":
                    result = "1562660433"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "carpet"){
                switch (value.toString()) {
                case "1":
                    result = "1562660697"
                    break;
                case "2":
                    result = "1562660704"
                    break;
                case "3":
                    result = "1562660716"
                    break;
                case "4":
                    result = "1562660722"
                    break;
                case "5":
                    result = "1562660729"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "duplex_floor"){
                switch (value.toString()) {
                case "2":
                    result = "1562661091"
                    break;
                case "3":
                    result = "1562661098"
                    break;
                case "4":
                    result = "1562661104"
                    break;
                case "5":
                    result = "1562661109"
                    break;
                default:
                    console.log("5");
                }
            }
        }

        //专项清洁
        if(this.order.data.type_id=="1550735962"){
            if (name == "house_layout"){
                result = '1562662349';
            }
            if (name == "carpet"){
                switch (value.toString()) {
                case "1":
                    result = "1562662365"
                    break;
                case "2":
                    result = "1562662370"
                    break;
                case "3":
                    result = "1562662375"
                    break;
                case "4":
                    result = "1562662381"
                    break;
                case "5":
                    result = "1562662387"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "duplex_floor"){
                switch (value.toString()) {
                case "2":
                    result = "1562662765"
                    break;
                case "3":
                    result = "1562662770"
                    break;
                case "4":
                    result = "1562662774"
                    break;
                case "5":
                    result = "1562662780"
                    break;
                default:
                    console.log("5");
                }
            }
        }

        //周期清洁
        if(this.order.data.type_id=="1550735971"){
            if (name == "house_layout"){
                switch (value.toString()) {
                case "1":
                    result = "1563859625"
                    break;
                case "2":
                    result = "1563859653"
                    break;
                case "3":
                    result = "1563859679"
                    break;
                case "4":
                    result = "1563859705"
                    break;
                case "5":
                    result = "1563859734"
                    break;
                case "6":
                    result = "1563859765"
                    break;
                case "7":
                    result = "1563859801"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "carpet"){
                switch (value.toString()) {
                case "1":
                    result = "1563860277"
                    break;
                case "2":
                    result = "1563860293"
                    break;
                case "3":
                    result = "1563860312"
                    break;
                case "4":
                    result = "1563860332"
                    break;
                case "5":
                    result = "1563860375"
                    break;
                default:
                    console.log("5");
                }
            }
            if (name == "duplex_floor"){
                switch (value.toString()) {
                case "2":
                    result = "1563862827"
                    break;
                case "3":
                    result = "1563862848"
                    break;
                case "4":
                    result = "1563862864"
                    break;
                case "5":
                    result = "1563862881"
                    break;
                default:
                    console.log("5");
                }
            }
        }
      return result;
    },

    toTextParking(theVar){
      let result = '';
      switch (theVar) {
        case "1551410087":
          result = '有停车位'
          break;
        case "1551410093":
          result = '无停车位'
          break;
        default:
          console.log("9");
      }
      return result;
    },
    toTextFloor(theVar){
      let result = '';
      switch (theVar) {
        case "1551412462":
          result = '有电梯/住G层'
          break;
        case "1551412475":
          result = '1层 无电梯'
          break;
        case "1551412486":
          result = '2层 无电梯'
          break;
        case "1551412499":
          result = '3层 无电梯'
          break;
        case "1551412509":
          result = '4层 无电梯'
          break;
        case "1551412525":
          result = '5层 无电梯'
          break;
        case "1551412535":
          result = '5层以上 无电梯'
          break;
        default:
          console.log("8");
      }
      return result;
    },
  },
  components: {
  },
  computed: {
    service_period: function () {
      let result = '';
      switch (this.order.data.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    service_type: function () {
      let result = '';
      switch (this.order.data.type_id) {
        case "1550735948":
          result = '大扫除清洁'
          break;
        case "1550735962":
          result = '专项清洁'
          break;
        case "1550735961":
          result = '短租屋清洁'
          break;
        case "1550735971":
          result = '周期清洁'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    priceSheet: function (){
      let result = '';
      switch (this.order.data.type_id) {
        case "1550735948":
          result = 'dasaochu'
          break;
        case "1550735962":
          result = 'zhuanxiang'
          break;
        case "1550735961":
          result = 'duanzuwu'
          break;
        case "1550735971":
          result = 'zhouqi'
          break;
        default:
          console.log("1");
      }
      return '/service/clean-price?service=' + result + '&back=yes';
    },
    house_type_duplex: function () {
      let type = '';
      let duplex = '';
      switch (this.order.data.house_type) {
        case "1":
          type = 'Apartment'
          break;
        case "2":
          type = 'Unit'
          break;
        case "3":
          type = 'House'
          break;
        case "4":
          type = 'Town House'
          break;
        case "5":
          type = 'Studio'
          break;
        case "6":
          type = 'Other'
          break;
        default:
          console.log("2");
      }
      switch (this.order.data.is_duplex) {
        case "0":
          duplex = '非复式'
          break;
        case "1":
          duplex = '复式'
          break;
        default:
          console.log("2");
      }
      let result = type + " " + duplex;
      if(this.order.data.is_duplex=="1"){
        result = result + this.order.data.duplex_floor + "层"
      }
      return result;
    },
    room_qty: function () {
      let type="";
      switch (this.order.data.house_layout) {
        case "1":
          type = '主卧 Master room'
          break;
        case "2":
          type = '一室一卫'
          break;
        case "3":
          type = '两室一卫'
          break;
        case "4":
          type = '两室两卫'
          break;
        case "5":
          type = '三室一卫'
          break;
        case "6":
          type = '三室两卫'
          break;
        case "7":
          type = '其他户型'
          break;
        default:
          console.log("2");
      }
      let result = type;

      if(this.order.data.carpet>0){
        result = result +" "+ this.order.data.carpet + "房地毯"
      }
      result =  result.replace(/more/g, '多')
      return result;
    },

  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "cleanEx"){
        this.order = localParsed;
        this.userCatch(this.order.data.type_id,this.order.data.address_name,this.order.data.address_phone,true);
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
    this.getPricing();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-cell__ft{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:70%;
  font-size:0.9em;
}

.mini-title{
  margin-top:20px;
  color: #595D68;
  font-size: 12pt;
  text-align: center;
  font-weight: bold;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.prepay-img{
  width:100%;
}

.container /deep/{

  .couponPd{
    padding-top:0;
    padding-bottom:0;
  }

  .weui-vcode-btn{
    padding-right:0;
    margin-left:10px;
    color:#ff7444;
  }

  .weui-cell_access .weui-cell__ft:after{
    border-color: #FE956A;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/pages/cleanEx/step5.vue